import { sendGenericEvent } from 'analytics/events/generics/sendGenericEvent'

enum MapsGenericEvents {
	SEARCH_STORE = 'search_store',
	SEARCH_STORE_HOURS = 'search_store_hours',
	SEARCH_STORE_MAP = 'search_store_map',
	SEARCH_STORE_NEARBY = 'search_store_nearby',
	SEARCH_STORE_NOT_FOUND = 'search_store_not_found',
	SEARCH_STORE_SELECT = 'search_store_select',
}

export function sendSearchStoreEvent() {
	sendGenericEvent(MapsGenericEvents.SEARCH_STORE)
}
export function sendSearchStoreNearbyEvent() {
	sendGenericEvent(MapsGenericEvents.SEARCH_STORE_NEARBY)
}
export function sendSearchStoreNotFoundEvent() {
	sendGenericEvent(MapsGenericEvents.SEARCH_STORE_NOT_FOUND)
}
export function sendSearchStoreHoursEvent() {
	sendGenericEvent(MapsGenericEvents.SEARCH_STORE_HOURS)
}
export function sendSearchStoreMapEvent() {
	sendGenericEvent(MapsGenericEvents.SEARCH_STORE_MAP)
}
export function sendSearchStoreSelectEvent() {
	sendGenericEvent(MapsGenericEvents.SEARCH_STORE_SELECT)
}
